import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../css/hotel-destination-card.css";

const HotelDestinationCard = ({ image, title, description, properties }) => {
  const navigate = useNavigate();
  const { category } = useParams(); // Get category from URL

  const handleExplore = () => {
    const formattedCity = title.toLowerCase().replace(/\s+/g, "-"); // Convert city to URL-friendly format
    navigate(`/destinations/${category}/${formattedCity}`);
  };

  return (
    <div className="hotel-destination-card swipe">
      <div className="hotel-destination-card-image">
        <img src={image} alt={title} loading="lazy" fetchPriority="high" />
      </div>
      <div className="hotel-destination-card-content">
        <div className="hotel-destination-card-content-header">
          <h1>{title}</h1>
          <p>{description}</p>
        </div>
        <div className="hotel-destination-card-content-footer">
          <h3>{properties} Propert{properties > 1 ? "ies" : "y"}</h3>
          <button onClick={handleExplore} name="explore">
            Explore
          </button>
        </div>
      </div>
    </div>
  );
};

export default HotelDestinationCard;
